import RoomPage from '../RoomPage';

const CreatorRoom = () => {
  return (
    <RoomPage
      roomName="Creator"
      roomTitle="動画撮影・編集"
      description="光と影、音と静寂。日常の中にある特別な瞬間を、映像という形で残します。派手なエフェクトよりも、空気感を大切にした映像制作。"
      heroGradient={{
        from: '#06443F',
        to: '#0A5952',
      }}
      works={[
        {
          title: 'ブランドムービー',
          description: 'ブランドの世界観を静かに伝える映像',
        },
        {
          title: 'インタビュー映像',
          description: '語る人の言葉と空気をそのまま残す',
        },
        {
          title: 'イベント記録',
          description: 'その場の空気感を大切にした記録映像',
        },
        {
          title: '旅行VLOG',
          description: '旅行の旅を記録して、旅の楽しさを伝えます。',
        },
        {
          title: '撮影、企画、編集',
          description: '撮影、企画、編集を担当して、動画を制作します。',
        },
      ]}
    />
  );
};

export default CreatorRoom;